var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 0.700195C5.12495 0.700195 0.824951 4.9752 0.824951 10.2502C0.824951 15.5252 5.09995 19.8002 10.375 19.8002C15.65 19.8002 19.9 15.5002 19.9 10.2502C19.9 5.0002 15.625 0.700195 10.375 0.700195ZM10.375 18.4502C5.84995 18.4502 2.17495 14.7752 2.17495 10.2502C2.17495 5.7252 5.84995 2.0502 10.375 2.0502C14.9 2.0502 18.575 5.7252 18.575 10.2502C18.575 14.7752 14.9 18.4502 10.375 18.4502Z",
    fill: "#858AF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 9.52539H11.025V6.45039C11.025 6.07539 10.725 5.77539 10.35 5.77539C9.97498 5.77539 9.67498 6.07539 9.67498 6.45039V9.50039H6.64997C6.27497 9.50039 5.97498 9.80039 5.97498 10.1754C5.97498 10.5504 6.27497 10.8504 6.64997 10.8504H9.69998V13.9004C9.69998 14.2754 9.99998 14.5754 10.375 14.5754C10.75 14.5754 11.05 14.2754 11.05 13.9004V10.8504H14.1C14.475 10.8504 14.775 10.5504 14.775 10.1754C14.75 9.82539 14.45 9.52539 14.1 9.52539Z",
    fill: "#858AF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleBlue);
export default __webpack_public_path__ + "static/media/plus_circle_blue.c0223ecbe4203f6879ef22b13421a729.svg";
export { ForwardRef as ReactComponent };